import { ApprovingInvoiceReportsSearchQuery } from '@/context/services/approving_invoice_reports';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export type FieldKey = keyof ApprovingInvoiceReportsSearchQuery;
export type FieldOrder = {
  key: FieldKey | FieldKey[];
  label: string;
  concatChar?: string;
  isDateField?: boolean;
  canShowPartialValue?: boolean;
  isAmountField?: boolean;
};

export const useConfigActiveSearchValuesOrder = () => {
  const { t } = useTranslation();

  const FIELD_ORDERS: FieldOrder[] = useMemo(
    () => [
      { key: 'query', label: t('transaction_items.search.keyword') },
      { key: 'number', label: t('approving_invoice_report_detail_number') },
      {
        key: 'status',
        label: t('approving_invoice_report_detail_application_status'),
      },
      {
        key: 'office_member_ids',
        label: t('applicant_office_member'),
        concatChar: '、',
      },
      { key: 'ap_payee_id', label: t('ap_payee') },
      { key: 'dept_ids', label: t('applicant_department'), concatChar: '、' },
      {
        key: 'report_dept_ids',
        label: t('selected_department'),
        concatChar: '、',
      },
      {
        key: ['total_amount_from', 'total_amount_to'],
        label: t('approving_invoice_reports.table.columns.total_amount'),
        concatChar: ' ~ ',
        canShowPartialValue: true,
        isAmountField: true,
      },
      { key: 'mf_file', label: t('attached_invoice') },
      { key: 'without_agent', label: t('exclude_proxy_approval') },
      {
        key: ['created_at_from', 'created_at_to'],
        label: t('approving_invoice_reports.table.columns.created_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['submitted_at_from', 'submitted_at_to'],
        label: t('approving_invoice_reports.table.columns.application_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['approved_at_from', 'approved_at_to'],
        label: t('approving_invoice_reports.table.columns.approval_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['book_date_from', 'book_date_to'],
        label: t(
          'approving_invoice_reports.table.columns.expense_booking_date'
        ),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['due_date_from', 'due_date_to'],
        label: t('approving_invoice_reports.table.columns.payment_due_date'),
        concatChar: ' - ',
        isDateField: true,
      },
    ],
    [t]
  );
  return { FIELD_ORDERS };
};
